import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from '../constants';

export interface ScheduleDraftPublishPayload {
  deviation: PapiDeviation;
  scheduleTs: number;
  onSuccess?: () => void;
}

export interface ScheduleDraftPublishSuccessPayload {
  deviation: PapiDeviation;
  scheduleTs: number;
  status: string;
}

export const scheduleDraftPublish = createAction(
  `${actionKey}.SCHEDULE_DRAFT_PUBLISH`,
  (payload: ScheduleDraftPublishPayload) => payload
);

export const scheduleDraftPublishSuccess = createAction(
  `${actionKey}.SCHEDULE_DRAFT_PUBLISH_SUCCESS`,
  (payload: ScheduleDraftPublishSuccessPayload) => payload
);

export const scheduleDraftPublishError = createAction(
  `${actionKey}.SCHEDULE_DRAFT_PUBLISH_ERROR`,
  (deviationId: number, errorCode: number | null) => ({
    deviationId,
    errorCode,
  })
);
